import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { getTop10Vistas } from "../api";
import "../assets/css/style.css";

const Top10Modal = ({ onClose, datos = [] }) => {
  const [topComercios, setTopComercios] = useState([]);
  const [cargado, setCargado] = useState(false);

  useEffect(() => {
    const cargar = async () => {
      const data = await getTop10Vistas();
      setTopComercios(data);
      setCargado(true);
    };
    cargar();
  }, []);
  

  const maxVistas = topComercios.length > 0 ? topComercios[0].vistas : 1;

  return (
    <AnimatePresence>
      {cargado && (
        <>
          <motion.div
            key="overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="overlay show"
            onClick={(e) =>
              e.target.classList.contains("overlay") && onClose()
            }
            style={{
              position: "fixed",
              inset: 0,
              backgroundColor: "rgba(0,0,0,0.8)",
              zIndex: 9998,
            }}
          />

          <motion.div
            key="modal"
            initial={{ y: "100%" }}
            animate={{ y: 0 }}
            exit={{ y: "100%" }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
            style={{
              position: "fixed",
              bottom: 0,
              left: 0,
              right: 0,
              zIndex: 9999,
              background: "#fff",
              borderRadius: "20px 20px 0 0",
              maxHeight: "90vh",
              overflowY: "auto",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{ textAlign: "center", padding: 20 }}>
              <h2 style={{ fontWeight: 600, fontSize: 15, borderBottom: "1px solid #eee", paddingBottom: 20 }}>
                Ranking élite: los 10 comercios más populares
              </h2>
            </div>

            <div style={{ padding: "0 15px" }}>
              {topComercios.map((item, i) => (
                <div key={item.id_comercio} style={{ marginBottom: 20 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <span style={{ fontWeight: 600, fontSize: 15, width: 24 }}>#{i + 1}</span>
                    <img
                      src={item.logo || "/assets/images/default.png"}
                      alt={item.nombre}
                      style={{ width: 28, height: 28, borderRadius: "50%", objectFit: "cover" }}
                    />
                    <span style={{ flex: 1, fontWeight: 700, fontSize: 14 }}>
                      <b>{item.nombre}</b>
                      <img src="/assets/images/verified.svg" className="verifiedUser" style={{ width: 300, marginLeft: 0 }} alt="Verificado" />
                    </span>
                    <span style={{ fontSize: 13, color: "#888" }}>{item.vistas} visitas</span>
                  </div>
                  <div
                    style={{
                      marginTop: 6,
                      height: 6,
                      background: "#eee",
                      borderRadius: 10,
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        height: "100%",
                        width: `${(item.vistas / maxVistas) * 100}%`,
                        background: "#1c97ea",
                        transition: "width 0.5s ease",
                      }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>

            <div style={{ textAlign: "center", padding: "10px 0 30px" }}>
              <button
                onClick={onClose}
                style={{
                  background: "white",
                  border: "none",
                  color: "#000",
                  fontWeight: "bold",
                }}
              >
                Cerrar
              </button>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default Top10Modal;
